import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { App } from 'App';
import { PersistGate } from 'redux-persist/integration/react';
import { persistor, store } from 'store';

import 'utils/prototype';

import reportWebVitals from './reportWebVitals';

import 'scss/index.scss';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
global.store = store;

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <App />
    </PersistGate>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
